<template>
  <el-dialog
    title="新增返利客户" :visible.sync="visible" @close="handleClose"
    width="500px">
    <el-form
      class="form"
      :model="form"
      :rules="rules"
      ref="form"
      :label-width="formLabelWidth">
      <el-form-item label="经营组织" prop="org">
        <ajax-select
          :disabled="showType === 'detail'"
          v-model="form.org"
          type="allArg"
          no-all
          clearable
          placeholder="请选择经营组织"
          valueField="obj"
          multiple
          isOrgFilter
          @change="handleOrgChange"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="customList">
        <search-select
          v-model="form.customList"
          placeholder="请输入关键词"
          type="customer"
          :key="form.customList ? form.customList.id : Date.now()"
          :disabled="!form.org"
          :extra-params="{ orgIds: orgList && orgList.length ? orgList : null}"
          :inital-option="form.custom"
          ref="cusSelect"></search-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../components/searchSelect'
import AjaxSelect from '../../../components/ajaxSelect/index'

export default {
  name: 'addOrEditDialog',
  components: { SearchSelect, AjaxSelect },
  props: {
    showType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: true,
      formLabelWidth: '120px',
      form: {
        org: [],
        customList: {}
      },
      rules: {
        customList: [
          { required: true, message: '请选择客户' }
        ],
        org: [
          { required: true, message: '请选择经营组织' }
        ]
      },
      orgList: []
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['rebateAccountSaveDm']),
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { org = [], customList = {} } = this.form
          if (!org || !org.length) {
            this.$message.warning('请选择组织')
            return
          }
          if (!customList.name) {
            this.$message.warning('请选择客户')
            return
          }
          const params = {
            customerName: customList.name,
            orgReqDtos: org.map(item => {
              return { orgId: item.id, orgName: item.deptName }
            })
          }
          this.rebateAccountSaveDm(params).then((res) => {
            if (res.success) {
              this.$message.success('新增成功')
              this.$emit('closeAdd', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    handleOrgChange (e) {
      console.log('[ e ] >', e)
      this.orgList = e && e.length && e.map(item => item.id)
    },
    handleClose () {
      this.$emit('closeAdd', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin: 0 auto;
}

.form-input, .form-select, .el-input-number {
  width: 200px;
}
.container-tag {
  margin-top: 5px;

  .el-tag {
    margin-right: 10px;
  }
}
.el-input-search{
  width: 180px;
}
</style>
